module.exports = __webpack_public_path__ + "static/media/opus-logo.84c74084.svg";